import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidePopupService {

  constructor() { }

  private currentPopup: Subject<any> = new Subject<any>();
  currentPopupChanged$ = this.currentPopup.asObservable();

  createNewPopup(id: string){
    this.currentPopup.next(id);
  }

  removePopup(){
    this.currentPopup.next(null);
  }
}
